module.exports = __webpack_public_path__ + "static/img/swiper19.a5db2812.png";